<ng-select
  #select
  class="ag-po-dropdown w-full"
  [formControl]="formControl"
  [items]="poOptions ? poOptions() : []"
  [clearable]="formControl.value"
  bindLabel="label"
  bindValue="value"
  appendTo="body"
  (change)="onChange()"
>
  <ng-template ng-option-tmp let-item="item">
    <div class="text-sm font-bold leading-5">
      {{ item.label }}
    </div>
  </ng-template>
</ng-select>
